<template>
  <div class="department">
    <div class="tree-content">
      <p class="people">
        全部人数<span>{{ currentEmployeeCount }}</span> /
        <span>{{ AllEmployees }}</span>
      </p>
      <el-tree
        class="tree"
        :data="Treedata"
        node-key="id"
        :expand-on-click-node="false"
        :default-expanded-keys="firstClassNodeIds"
        @node-click="handleNodeClick"
      >
        <span class="custom-tree-nodes" slot-scope="{ node, data }">
          <span class="people-img" v-show="!data.deptName">
            <i class="el-icon-s-check"></i>
          </span>
          <span class="title-label">{{ node.label }}</span>
          <!-- 判断是否是部门 -->
          <span class="button-operator" v-show="showOperator">
            <!-- 只有点击当前按钮是才显示操作按钮 -->
            <span v-show="data.id == clickId" class="spanclickId">
              <el-button
                type="text"
                size="mini"
                @click.stop="() => handleEdit(node, data)"
                v-show="data.id != institutionId"
                ><i class="el-icon-edit"></i
              ></el-button>
              <el-button
                type="text"
                size="mini"
                @click.stop="() => hanldeAdd(data)"
                ><i class="el-icon-circle-plus-outline"></i
              ></el-button>
              <!-- v-if="data.pid!=0"  判断一级节点不能删除 by guo 2019-08-20 添加-->
              <el-button
                type="text"
                size="mini"
                v-if="data.pid != 0"
                @click.stop="() => hanldeRemove(node, data)"
                ><i class="el-icon-delete"></i
              ></el-button>
            </span>
          </span>
        </span>
      </el-tree>
    </div>

    <!-- 员工列表展示     -->
    <div class="table-content">
      <table-base
        :tableData="dataList"
        @page-change="pageChange"
        @currentpage-change="clickChange"
        :loading="tableloading"
        :len="tabelLen"
        :pageNum="pageNum"
        :pageSize="pageSize"
        :pageName="AcurrentPage"
        :titleStyle="titleStyle"
        
      >
        <template slot="header">
          <el-button
            type="warning"
            plain
            class="el-icon-plus title-btn"
            @click="handleAddEmployee"
            >新增员工</el-button
          >
          <el-button
              type="info"
              @click="downEmployee"
              icon="el-icon-download"
              plain
              >员工信息导出</el-button>

          <el-button type="info" @click="toLead" icon="el-icon-upload" plain>表格导入</el-button>

        </template>
        <template slot="table">
          <el-table-column
            prop="userName"
            label="员工姓名"
            align="center"
            :show-overflow-tooltip="true"
            min-width="100"
          >
          </el-table-column>
          <el-table-column
            prop="loginName"
            label="登录名"
            align="center"
            :show-overflow-tooltip="true"
            min-width="100"
          >
          </el-table-column>
          <!-- <el-table-column
            prop="idCard"
            label="身份证号码"
            align="center"
            :show-overflow-tooltip="true"
            width="150"
          >
          </el-table-column> -->
          <el-table-column
            prop="mobileNo"
            label="手机号码"
            align="center"
            :show-overflow-tooltip="true"
            min-width="100"
          >
          </el-table-column>
          <el-table-column
            prop="empDate"
            label="入职日期"
            align="center"
            :show-overflow-tooltip="true"
            min-width="100"
          >
          </el-table-column>
          <el-table-column
            prop="department"
            label="所属部门"
            align="center"
            :show-overflow-tooltip="true"
            min-width="100"
          >
          </el-table-column>
          <el-table-column
            prop="position"
            label="就职职位"
            align="center"
            :show-overflow-tooltip="true"
            min-width="100"
          >
          </el-table-column>
          <!--新添加 角色 by guo 2019-8-7 10:20 添加 -->
          <el-table-column
            prop="roleName"
            label="角色"
            align="center"
            :show-overflow-tooltip="true"
            min-width="80"
          >
          </el-table-column>
          <el-table-column
            prop="lastLoginTime"
            label="最后登录时间"
            align="center"
            :show-overflow-tooltip="true"
            min-width="150">
          </el-table-column>
          <el-table-column
            label="操作"
            class-name="operator"
            width="250"
            align="center"
          >
            <template slot-scope="scope">
              
              <el-button size="mini" @click="fixpass(scope.$index, scope.row)"
                >密码重置</el-button
              >
              <el-button
                type="primary"
                size="mini"
                plain
                @click="handleEmployeeEdit(scope.$index, scope.row)"
                >编辑</el-button
              >

              <!-- icon="el-icon-delete" -->
              <el-button
                type="danger"
                size="mini"
                plain
                @click="handleEmployeeDelete(scope.$index, scope.row)"
                >删除</el-button
              >
              <!-- <el-button size="mini" @click="handleEmployeeEdit(scope.$index, scope.row)" class="operatorEdit">修改</el-button>
                      <el-button size="mini" @click="handleEmployeeDelete(scope.$index, scope.row)" class="operatorDelete">删除</el-button>
                      <el-button size="mini" @click="fixpass(scope.$index, scope.row)" >密码重置</el-button> -->
            </template>
          </el-table-column>
        </template>
      </table-base>
      <el-dialog
        title="重置密码"
        :visible.sync="passDialogVisible"
        width="30%"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="closePassDialogVisible"
        center
      >
        <el-form
          :model="passDetail"
          label-width="120px"
          :rules="passRule"
          ref="passDetail"
        >
          <el-form-item label="新密码" prop="pass">
            <el-input
              type="password"
              v-model.trim="passDetail.pass"
              style="width: 80%"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认新密码" prop="newPass">
            <el-input
              type="password"
              v-model.trim="passDetail.newPass"
              style="width: 80%"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="passDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addPass">确 定</el-button>
        </span>
      </el-dialog>
    </div>

    <!-- 报表上传 -->
      <el-dialog title="表格导入" width="30%" :visible.sync="toLeadVisisble" :close-on-click-modal="false"
        @close="toLeadCloseDialog">
        <el-row type="flex" justify="center">
          <el-col :span="20">
            <el-row>
              <el-col :span="24">
                <input type="file" ref="file" id="file" @change="getUrl" />
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click.native="toLeadVisisble = false">取消</el-button>
          <el-button type="primary" @click.native="intoForm">确定</el-button>
        </div>
      </el-dialog>


        <!-- 添加部门 -->
        <el-dialog
        width="400px"
        :visible.sync="addDialogFormVisible"
        :close-on-click-modal="false"
      >
        <div slot="title" class="dialog-title">新建部门信息</div>
        <el-form
          :model="addDepartData"
          :rules="addDepartformRules"
          ref="addDepartform"
        >
          <el-form-item
            label="部门名称"
            prop="depname"
            :label-width="formLabelWidth"
          >
            <el-input
              v-model.trim="addDepartData.depname"
              maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item label="部门描述" :label-width="formLabelWidth">
            <el-input
              type="textarea"
              v-model.trim="addDepartData.desc"
              maxlength="300"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addDialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click.stop="addDepartment('addDepartform')"
            >确 定</el-button
          >
        </div>
      </el-dialog>
      <!-- 修改部门 -->
      <el-dialog
        width="400px"
        :visible.sync="editDialogFormVisible"
        :close-on-click-modal="false"
      >
        <div slot="title" class="dialog-title">修改部门信息</div>
        <el-form
          :model="editDepartData"
          :rules="editDepartformRules"
          ref="editDepartform"
        >
          <el-form-item
            label="部门名称"
            prop="editDepname"
            :label-width="formLabelWidth"
          >
            <el-input
              v-model.trim="editDepartData.editDepname"
              maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item label="部门描述" :label-width="formLabelWidth">
            <el-input
              type="textarea"
              v-model.trim="editDepartData.etidDesc"
              maxlength="300"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editDialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click.stop="editDepartment('editDepartform')"
            >确 定</el-button
          >
        </div>
      </el-dialog>
  
      <!-- 添加员工 -->
      <el-dialog
        width="700px"
        :visible.sync="addEmployeeDialogVisible"
        :close-on-click-modal="false"
        class="add-employee"
        @close="closeAddEmployee"
      >
        <div slot="title" class="dialog-title">添加员工</div>
        <el-form
          :model="addEmploeeData"
          :rules="addEmployeeFormRules"
          ref="addEmployeeForm"
        >
          <div class="left-form">
            <el-form-item
              label="员工姓名"
              prop="userName"
              
              :label-width="formLabelWidth"
            >
              <el-input
                v-model.trim="addEmploeeData.userName"
                maxlength="15"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="身份证号"
              prop="idCard"
              :label-width="formLabelWidth"
            >
              <el-input v-model.trim="addEmploeeData.idCard"></el-input>
            </el-form-item>
            <el-form-item
              label="入职日期"
              prop="empDate"
              :label-width="formLabelWidth"
            >
              <el-date-picker
                v-model="addEmploeeData.empDate"
                type="date"
                :editable="false"
                :picker-options="pickerDate"
                @change="enterdate"
              ></el-date-picker>
            </el-form-item>
            <el-form-item
              label="就职职务"
              prop="position"
              :label-width="formLabelWidth"
            >
              <el-input
                v-model.trim="addEmploeeData.position"
                maxlength="15"
              ></el-input>
            </el-form-item>
            <!-- 人员类型  by guo 2019-12-03 17:30 添加 -->
            <el-form-item
              label="人员类型"
              prop="personnelType"
              :label-width="formLabelWidth"
            >
              <el-select
                v-model.trim="addEmploeeData.personnelType"
                filterable
                default-first-option
                style="width: 100%"
              >
                <el-option
                  v-for="item in personnelTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- 角色 by guo 2019-8-7 9:46 添加 -->
            <el-form-item
              label="角色"
              prop="roleId"
              :label-width="formLabelWidth"
            >
              <el-select
                v-model="addEmploeeData.roleId"
                filterable
                default-first-option
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in roleOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="right-form">
            <el-form-item
              label="登录账号"
              prop="loginName"
              :label-width="formLabelWidth"
            >
              <el-input
                v-model.trim="addEmploeeData.loginName"
                maxlength="20"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="手机号码"
              prop="mobileNo"
              :label-width="formLabelWidth"
            >
              <el-input v-model.trim="addEmploeeData.mobileNo"></el-input>
            </el-form-item>
            <el-form-item
              label="所属部门"
              prop="deptId"
              :label-width="formLabelWidth"
            >
              <el-select
                v-model="addEmploeeData.deptId"
                filterable
                default-first-option
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in AllDeapartments"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="家庭住址"
              prop="famliyAddr"
              :label-width="formLabelWidth"
            >
              <el-input
                v-model.trim="addEmploeeData.famliyAddr"
                maxlength="30"
              ></el-input>
            </el-form-item>
            <!-- 文化程度 by guo 2019-12-03-17:36添加 -->
            <el-form-item
              label="文化程度"
              prop="educationLevel"
              :label-width="formLabelWidth"
            >
              <el-select
                v-model.trim="addEmploeeData.educationLevel"
                filterable
                default-first-option
                style="width: 100%"
              >
                <el-option
                  v-for="item in educationLevelList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            @click.stop="addEmploeeSubmit('addEmployeeForm')"
            >确 定</el-button
          >
          <el-button @click="resetEmployeeForm('addEmployeeForm')"
            >重置</el-button
          >
        </div>
      </el-dialog>
      <!-- 修改员工 -->
      <el-dialog
        width="700px"
        :visible.sync="editEmployeeDialogVisible"
        :close-on-click-modal="false"
        class="edit-employee"
        @close="closeEditEmployee"
      >
        <div slot="title" class="dialog-title">修改员工</div>
        <el-form
          :model="editEmploeeData"
          :rules="editEmployeeFormRules"
          ref="editEmployeeForm"
        >
          <div class="left-form">
            <el-form-item
              label="员工姓名"
              prop="userName"
              :label-width="formLabelWidth"
            >
              <el-input
                v-model.trim="editEmploeeData.userName"
                maxlength="15"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="身份证号"
              prop="idCard"
              :label-width="formLabelWidth"
            >
              <el-input v-model.trim="editEmploeeData.idCard"></el-input>
            </el-form-item>
            <el-form-item
              label="入职日期"
              prop="empDate"
              :label-width="formLabelWidth"
            >
              <el-date-picker
                v-model="editEmploeeData.empDate"
                type="date"
                :editable="false"
                @change="editDatePickerChange"
                :picker-options="pickerDate"
              ></el-date-picker>
            </el-form-item>
            <el-form-item
              label="就职职务"
              prop="position"
              :label-width="formLabelWidth"
            >
              <el-input
                v-model.trim="editEmploeeData.position"
                maxlength="15"
              ></el-input>
            </el-form-item>
            <!-- 角色 by guo 2019-8-7 9:46 添加 -->
            <el-form-item
              label="角色"
              prop="roleId"
              :label-width="formLabelWidth"
            >
              <el-select
                v-model="editEmploeeData.roleId"
                filterable
                default-first-option
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in roleOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- 人员类型  by guo 2019-12-03 17:30 添加 -->
            <el-form-item
              label="人员类型"
              prop="personnelType"
              :label-width="formLabelWidth"
            >
              <el-select
                v-model.trim="editEmploeeData.personnelType"
                filterable
                default-first-option
                style="width: 100%"
              >
                <el-option
                  v-for="item in personnelTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="right-form">
            <el-form-item
              label="登录名"
              prop="loginName"
              :label-width="formLabelWidth"
            >
              <el-input
                v-model.trim="editEmploeeData.loginName"
                maxlength="20"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="手机号码"
              prop="mobileNo"
              :label-width="formLabelWidth"
            >
              <el-input v-model.trim="editEmploeeData.mobileNo"></el-input>
            </el-form-item>
            <el-form-item
              label="所属部门"
              prop="deptId"
              :label-width="formLabelWidth"
            >
              <el-select
                v-model.trim="EditdDeptId"
                filterable
                default-first-option
                @change="editEmploeeChange"
                style="width: 100%"
              >
                <el-option
                  v-for="item in AllDeapartments"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="家庭住址"
              prop="famliyAddr"
              :label-width="formLabelWidth"
            >
              <el-input
                v-model.trim="editEmploeeData.famliyAddr"
                maxlength="30"
              ></el-input>
            </el-form-item>
            <!-- 文化程度 by guo 2019-12-03-17:36添加 -->
            <el-form-item
              label="文化程度"
              prop="educationLevel"
              :label-width="formLabelWidth"
            >
              <el-select
                v-model.trim="editEmploeeData.educationLevel"
                filterable
                default-first-option
                style="width: 100%"
              >
                <el-option
                  v-for="item in educationLevelList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            @click.stop="editEmploeeSubmit('editEmployeeForm')"
            >确 定</el-button
          >
          <!-- <el-button @click="editResetEmployeeForm('editEmployeeForm')">重置</el-button> -->
          <!-- by guo 2019-08-20  17:19  修改 -->
          <el-button @click="editEmployeeDialogVisible = false">取消</el-button>
        </div>
      </el-dialog>
  
  </div>
</template>
<script type="text/javascript">
import util from "@/utils/dayUtil.js";
import { baseURL } from "@/utils/request.js";
import TableBase from "@/components/common-table.vue";
let id = 1000;
export default {
  components: { TableBase },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.passDetail.newPass !== "") {
          this.$refs.passDetail.validateField("newPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.passDetail.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    const Treedata = [
      {
        id: 100,
        label: "乐活智享科技有限公司",
        children: [
          {
            id: 1,
            label: "一级 1",
            children: [
              {
                id: 4,
                label: "二级 1-1",
                children: [
                  {
                    id: 9,
                    label: "三级 1-1-1",
                  },
                  {
                    id: 10,
                    label: "三级 1-1-2",
                  },
                ],
              },
            ],
          },
        ],
      },
    ];
    var checkName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("部门名称不能为空"));
      } else {
        // 正确的时候记得callback
        callback();
      }
    };
    var validateIdCard = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("身份证号不能为空"));
      } else {
        //  老身份证15位  新身份证18位(最后一位可以使x)
        var reg = /^(\d{15}|\d{17}[xX\d])$/;
        if (!reg.test(value)) {
          callback(new Error("请输入正确的身份证号码"));
        } else {
          callback();
        }
      }
    };
    var validateMobile = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入手机号"));
      } else {
        //  因为现在新增了166、198、199号段的手机号
        var reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
        if (!reg.test(value)) {
          callback(new Error("手机号码格式错误"));
        } else {
          callback();
        }
      }
    };
    var validateEditDeptId = (rule, value, callback) => {
      this.editEmploeeData.deptId = value;
      if (!value) {
        return callback(new Error("请选择所属部门"));
      } else {
        callback();
      }
    };
    return {
      userId: "", //当前用户id by xiang
      passDialogVisible: false, //重置密码弹窗 by xiang
      passDetail: {
        pass: "",
        newPass: "",
      }, //密码重置信息 by xiang
      groupId: "", //机构id by guo 2019-8-21 13:08 添加
      roleOptions: [], //角色集合  by guo 2019-8-7 9:48添加
      EditdDeptId: "",
      Treedata: JSON.parse(JSON.stringify(Treedata)),
      addEmployeeDialogVisible: false,
      editEmployeeDialogVisible: false,
      addDialogFormVisible: false,
      editDialogFormVisible: false,
      formLabelWidth: "100px",
      addDepartData: {
        depname: "",
        desc: "",
      },
      editDepartData: {
        editDepname: "",
        etidDesc: "",
      },
      addDepartformRules: {
        depname: [{ required: true, validator: checkName, trigger: "blur" }],
      },
      editDepartformRules: {
        editDepname: [
          { required: true, validator: checkName, trigger: "blur" },
        ],
      },
      nodeData: {},
      dataList: [],
      editEmploeeData: {
        deptId: "",
        position: "",
        famliyAddr: "",
        empDate: "",
        mobileNo: "",
        userName: "",
        loginName: "",
        idCard: "",
        roleId: "", //角色id  by guo 2019-8-7 9:46添加
        personnelType: "", //人员类型 by guo 2019-12-03 17:39添加
        educationLevel: "", //教育程度 by guo 2019-12-03 17:39 添加
      },
      //密码重置校验by xiang
      passRule: {
        pass: [
          { required: true, validator: validatePass, trigger: "blur" },
          { min: 6, max: 16, message: "请输入6到16个字符" },
        ],
        newPass: [
          { required: true, validator: validatePass2, trigger: "blur" },
          { min: 6, max: 16, message: "请输入6到16个字符" },
        ],
      },

      editEmployeeFormRules: {
        userName: [
          { required: true, message: "用户名不能为空", trigger: "blur" },
        ],
        idCard: [
          { required: true, validator: validateIdCard, trigger: "blur" },
        ],
        empDate: [
          { required: true, message: "入职日期不能为空", trigger: "blur" },
        ],
        position: [
          { required: true, message: "职位信息不能为空", trigger: "blur" },
        ],
        loginName: [
          { required: true, message: "登录名不能为空", trigger: "blur" },
        ],
        mobileNo: [
          { required: true, validator: validateMobile, trigger: "blur" },
        ],
        deptId: [
          { required: true, message: "请选择所属部门", trigger: "change" },
        ],
        famliyAddr: [
          { required: true, message: "请输入家庭地址", trigger: "blur" },
        ],
        // 角色 by guo 2019-8-7 9:46添加
        roleId: [{ required: true, message: "请选择角色", trigger: "change" }],
        // 人员类型 by guo 2019-12-03 17:40添加
        personnelType: [
          { required: true, message: "请选择人员类型", trigger: "change" },
        ],
        // 教育程度 by guo 2019-12-03 17:40添加
        educationLevel: [
          { required: true, message: "请选择教育程度", trigger: "change" },
        ],
      },
      addEmploeeData: {
        deptId: "",
        position: "",
        famliyAddr: "",
        empDate: "",
        mobileNo: "",
        userName: "",
        loginName: "",
        idCard: "",
        roleId: "", //角色id  by guo 2019-8-7 9:46添加
        personnelType: "", //人员类型 by guo 2019-12-03 17:39添加
        educationLevel: "", //教育程度 by guo 2019-12-03 17:39 添加
      },
      addEmployeeFormRules: {
        userName: [
          { required: true, message: "用户名不能为空", trigger: "blur" },
        ],
        idCard: [
          { required: true, validator: validateIdCard, trigger: "blur" },
        ],
        empDate: [
          { required: true, message: "入职日期不能为空", trigger: "blur" },
        ],
        position: [
          { required: true, message: "职位信息不能为空", trigger: "blur" },
        ],
        loginName: [
          { required: true, message: "登录名不能为空", trigger: "blur" },
        ],
        mobileNo: [
          { required: true, validator: validateMobile, trigger: "blur" },
        ],
        deptId: [
          { required: true, message: "请选择所属部门", trigger: "change" },
        ],
        famliyAddr: [
          { required: true, message: "请输入家庭地址", trigger: "blur" },
        ],
        // 角色 by guo 2019-8-7 9:46添加
        roleId: [{ required: true, message: "请选择角色", trigger: "change" }],
        // 人员类型 by guo 2019-12-03 17:40添加
        personnelType: [
          { required: true, message: "请选择人员类型", trigger: "change" },
        ],
        // 教育程度 by guo 2019-12-03 17:40添加
        educationLevel: [
          { required: true, message: "请选择教育程度", trigger: "change" },
        ],
      },
      pageNum: 1,
      pageSize: 10,
      searchEmployeeParams: {
        pageNum: 1,
        pageSize: 10,
        // deptId: 1
        deptId: "", // by guo 2019 3-22   deptId不能默认写成1  ，新建一个大的部门会有bug，还会显示之前的数据，不会显示新建的，要点击才显示
      },
      tableloading: false,
      tabelLen: 0,
      AcurrentPage: "employee-page",
      titleStyle: "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #efefef;",
      AllDeapartments: [],
      EidtAllDeapartments: [],
      employeesList: [],
      toLeadVisisble:false,
      clickId: "",
      showOperator: false,
      isExpandNode: true,
      pidList: [],
      addFlag: true,
      secondAddFlag: false,
      firstClassNodeIds: [],
      institutionId: 0,
      AllEmployees: 0,
      currentEmployeeCount: 0,
      pickerDate: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      username: "",
      password: "",
      check: "",
      loginUserId: "", //获取登录用户的userId
      personnelTypeList: [
        { label: "正式编制", value: "0" },
        { label: "非正式编制", value: "1" },
      ],
      educationLevelList: [
        { label: "高中", value: "1" },
        { label: "大专", value: "2" },
        { label: "本科", value: "3" },
        { label: "研究生", value: "4" },
        { label: "博士", value: "5" },
        { label: "小学", value: "6" },
        { label: "初中", value: "7" },
      ],
    };
  },
  methods: {
    //密码重置 by xiang
    fixpass(idnex, row) {
      this.passDialogVisible = true;
      this.userId = row.userId;
    },

    //提交密码 by xiang
    addPass() {
      this.$refs["passDetail"].validate((valid) => {
        if (valid) {
          let param = {
            userId: this.userId,
            password: this.passDetail.pass,
            confirmPwd: this.passDetail.newPass,
          };
          this.$postJson("uac/user/resetPwd", param).then((res) => {
            if (res.code == 200) {
              this.passDialogVisible = false;
              this.$message({ message: res.message, type: "success" });
              
              if (this.loginUserId == this.userId) {
                //判断修改的是不是当前的用户  如果是当期用户就退出   不是的话就不退出到登录页
                this.$router.push({
                  name: "login",
                  params: {
                    username: this.username,
                    password: this.password,
                    check: this.check,
                  },
                });
              }
            } else {
              this.$message({ message: res.message, type: "error" });
            }
          });
        } else {
          return false;
        }
      });
    },
    //关闭密码重置弹窗 by xiang
    closePassDialogVisible() {
      this.$nextTick(() => {
        this.$refs["passDetail"].resetFields();
      });
    },

    closeAddEmployee() {
      this.$refs.addEmployeeForm.resetFields();
    },
    closeEditEmployee() {
      this.$refs.editEmployeeForm.resetFields();
    },
    addSelectChange(val) {
      var departments = this.AllDeapartments;
      departments.forEach((item) => {
        if (val == item.value) {
          this.addEmploeeData.deptId = item.label;
        }
      });
    },
    editEmploeeChange(val) {
      var departments = this.AllDeapartments;
      departments.forEach((item) => {
        if (val == item.value) {
          this.editEmploeeData.deptId = item.label;
        }
      });
    },
    handleNodeClick(data, node, dom) {
      this.nodeData = data;

      if (data.children != null || data.hasDept || data.deptName != null) {
        if (this.clickId == data.id) {
          if (node.data.deptName) {
            this.showOperator = !this.showOperator;
          }
        } else {
          this.showOperator = false;
          if (node.data.deptName) {
            this.showOperator = !this.showOperator;
          }
        }

        this.clickId = data.id;

        // 点击节点得到员工数据---不能分页
        // this.getDepartEmployees(data)

        // 点击的时候去请求员工数据
        this.dataList = []; //初始化避免累加
        this.searchEmployeeParams.deptId = +data.id;
        this.searchEmployeeParams.pageNum = 1; //每次点击节点的时候pageNum就要置为1

        this.clickChange(1); //他的高亮也要显示第一页--只能通过点击--移除active不会渲染dom
        // 不会改变DOM
        // this.lightFirstPage()
        this.searchEmployeeByDeptId();

        // 回填数据
        this.editDepartData.editDepname = this.nodeData.label;
        this.editDepartData.etidDesc = this.nodeData.desc;
      }
    },

    toLead() {
      this.toLeadVisisble = true;
    },
    toLeadCloseDialog() {
      this.$refs.file.value = "";
    },
    getUrl(event) {
      let file = event.target.files;
      console.log(file);
      this.fileFlag = true; //by guo 2020-8-4-15:18添加
      this.toLeadForm = new FormData();
      this.toLeadForm.append("file", file[0]);
    },
    // 确认上传
    intoForm() {
      if (this.fileFlag) {
        this.$postFormData("uac/emp/toLead", this.toLeadForm).then((res) => {
          this.toLeadVisisble = false;
          this.fileFlag = false;
          this.toLeadForm = {};
          if (res.code == 200) {
            this.$message({ message: res.message, type: "success" });
            this.queryOldman();
          } else {
            this.$message({ message: res.message, type: "error" });
          }
        });
      } else {
        this.$message({ message: "请选择文件", type: "error" });
      }
    },

    lightFirstPage() {
      var pageArray = document.querySelector(".el-pager");
      var childrens = [...pageArray.children];
      childrens.forEach((item) => {
        item.classList.remove("active");
      });
      pageArray.children[0].classList.add("active");
    },
    getDepartEmployees(data) {
      // 每次请求之前把dataList清空避免累加
      this.dataList = [];
      if (data.empVoList && data.empVoList.length > 0) {
        data.empVoList.forEach((item) => {
          this.transformEmployeeParams(data, item);
        });
      }
      this.tabelLen = this.dataList.length;
    },
    transformEmployeeParams(data, item) {
      // 获取员工到部门名称后再添加入列表
      var employee = {};
      employee.userName = item.userName;
      employee.loginName = item.loginName;
      employee.idCard = item.idCard;
      employee.mobileNo = item.mobileNo;
      employee.empDate = item.empDate;
      employee.position = item.position;
      employee.famliyAddr = item.famliyAddr;
      employee.lastLoginTime = item.lastLoginTime;
      employee.department = data.deptName;
      employee.userId = item.userId;
      employee.roleName = item.roleName; //by guo 2019-8-7 10:24 添加  角色名称
      employee.roleId = item.roleId; //by guo 2019-8-7 10:24 添加  角色roleId
      this.dataList.push(employee);
    },
    handleEdit() {
      this.editDialogFormVisible = true;
      // 编辑框显示马上回显数据
      this.$refs["editDepartform"].resetFields();
      this.editDepartData.editDepname = this.nodeData.label;
      this.editDepartData.etidDesc = this.nodeData.desc;
    },
    hanldeAdd() {
      this.addDialogFormVisible = true;
      // 弹出框显示马上清空数据
      this.$refs["addDepartform"].resetFields();
      this.addDepartData.desc = "";
    },
    downEmployee(){
      this.$confirm('此操作将导出所有员工的信息', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.baobiaosubmitForm();
        })
    },
    baobiaosubmitForm() {
      window.location.href =
        baseURL +
        `uac/api/downEmployeeList?groupId=${window.sessionStorage.getItem("groupId")}`;
      setTimeout(() => {
        this.fieldsVisisble = false;
      }, 1000);
    },
    handleAddEmployee() {
      this.addEmployeeDialogVisible = true;
    },
    addDepartment(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addDialogFormVisible = false;
          this.checkSubmitNameUnique();
        } else {
          return false;
        }
      });
    },
    editDepartment(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editDialogFormVisible = false;
          this.checkUpdateNameUnique();
        } else {
          return false;
        }
      });
    },
    checkUpdateNameUnique() {
      let params = {
        deptId: this.nodeData.id,
        pid: this.nodeData.pid,
        deptName: this.editDepartData.editDepname,
      };
      this.$postJson("uac/dept/checkDeptName", params).then((res) => {
        if (res.code === 200) {
          if (res.result) {
            this.editDepartmentSubmit();
          } else {
            this.$message.error("部门名称重复修改失败");
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    editDepartmentSubmit() {
      let params = {
        id: this.nodeData.id,
        pid: this.nodeData.pid,
        deptName: this.editDepartData.editDepname,
        remark: this.editDepartData.etidDesc,
      };
      this.$postJson("uac/dept/save", params).then((res) => {
        if (res.code === 200) {
          this.$message.success("修改部门信息成功");
          this.$refs["editDepartform"].resetFields();
          this.searchEmployeeByDeptId(); // by guo 2019-8-20 17:00修改
          this.getDepartInfo();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    checkSubmitNameUnique() {
      let params = {
        pid: this.nodeData.id,
        deptName: this.addDepartData.depname,
      };
      this.$postJson("uac/dept/checkDeptName", params).then((res) => {
        if (res.code === 200) {
          if (res.result) {
            this.addDepartmentSubmit();
          } else {
            this.$message.error("部门名称重复新增失败");
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    addDepartmentSubmit() {
      let params = {
        pid: this.nodeData.id,
        deptName: this.addDepartData.depname,
        remark: this.addDepartData.desc,
      };
      this.$postJson("uac/dept/save", params).then((res) => {
        if (res.code === 200) {
          this.$message.success("新建部门信息成功");
          this.$refs["addDepartform"].resetFields();
          this.searchEmployeeByDeptId(); // by guo 2019-8-20 17:00修改
          this.getDepartInfo();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    hanldeRemove() {
      this.$confirm("此操作将永久删除该部门, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        closeOnClickModal: false,
      })
        .then(() => {
          if (this.nodeData.pid === "0") {
            this.$message.error("根部门不能删除");
          } else if (this.nodeData.hasDept) {
            this.$message.error("部门下面有子部门删除失败");
          } else if (
            this.nodeData.empVoList &&
            this.nodeData.empVoList.length > 0
          ) {
            this.$message.error("部门下面有员工删除失败");
          } else {
            this.removeDepartment();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    removeDepartment() {
      let param = {};
      this.$postJson(
        "uac/dept/deleteUacDeptById/" + this.nodeData.id,
        param
      ).then((res) => {
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.searchEmployeeByDeptId(); // by guo 2019-8-20 17:00修改
          this.getDepartInfo();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    enterdate(val) {
      this.addEmploeeData.empDate = util.formatDate.format(val, "yyyy-MM-dd");
    },
    addEmploeeSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var data = this.addEmploeeData;
          if (isNaN(+data.deptId)) {
            // 不是数字
            var departments = this.AllDeapartments;
            departments.forEach((item) => {
              if (data.deptId == item.label) {
                data.deptId = +item.value;
              }
            });
          } else {
            data.deptId = +data.deptId;
          }
          let params = data;
          // 添加员工
          this.$postJson("uac/emp/saveWithRole", params).then((res) => {
            if (res.code === 200) {
              this.$message.success("添加员工信息成功");
              this.$refs["addEmployeeForm"].resetFields();
              this.addEmployeeDialogVisible = false;
              this.searchEmployeeByDeptId(); // by guo 2019-8-7 10:41
              this.getDepartInfo();
            } else {
              this.addSelectChange(data.deptId);
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    editDatePickerChange(val) {
      this.editEmploeeData.empDate = util.formatDate.format(
        this.editEmploeeData.empDate,
        "yyyy-MM-dd"
      );
    },
    editEmploeeSubmit(formName) {
      var EditEmptdata = this.editEmploeeData;

      var departments = this.EidtAllDeapartments;
      departments.forEach((item) => {
        if (this.editEmploeeData.deptId === item.label) {
          this.editEmploeeData.deptId = +item.value;
        }
      });
      this.editEmploeeData.userId = +this.editEmploeeData.userId;
      if (this.editEmploeeData.department) {
        delete this.editEmploeeData.department;
      }


      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = this.editEmploeeData;
          // 修改员工
          // this.$postJson('uac/emp/edit', params).then(res => {
          //by guo 2019-8-7 guo 修改  新接口添加了一个字段 roleId
          this.$postJson("uac/emp/editWithRole", params).then((res) => {
            if (res.code === 200) {
              this.$message.success("修改员工信息成功");
              this.$refs["editEmployeeForm"].resetFields();
              this.editEmployeeDialogVisible = false;
              this.searchEmployeeByDeptId(); // by guo 2019-8-20 17:00修改
              this.getDepartInfo();
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    pageChange(val) {
      this.dataList = []; //初始化避免累加
      this.searchEmployeeParams.pageNum = val;
      this.searchEmployeeByDeptId();
    },
    clickChange(val) {
      setTimeout(function () {
        var pageArray = document.querySelector(".el-pager");
        if (pageArray != null) {
          var num = Number(val) - 1;
          // click之前把数据清空
          this.dataList = []; //初始化避免累加
          pageArray.children[num].click();
        }
      }, 500);
    },
    handleEmployeeEdit(index, row) {
      this.editEmployeeDialogVisible = true;
      // 避免弹出层修改的时候--底部的table也在改变
      this.editEmploeeData =  Object.assign({}, row);
      this.editEmploeeData.deptId = row.department;
      this.EditdDeptId = row.department;
    },
    handleEmployeeDelete(index, row) {
      this.$confirm("此操作将删除该员工, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        closeOnClickModal: false,
      })
        .then(() => {
          this.deleteEmployee(row);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    deleteEmployee(row) {
      this.$postForm("uac/emp/deleteUacEmpByUserId/" + row.userId).then(
        (res) => {
          if (res.code == 200) {
            this.$message.success("成功删除员工");
            this.editEmployeeDialogVisible = false;
            this.searchEmployeeByDeptId(); // by guo 2019-8-20 17:00修改
            this.getDepartInfo();
          } else {
            this.$message.error(res.message);
          }
        }
      );
    },
    deepCopy(obj) {
      if (typeof obj !== "object") return;
      var newObj = obj instanceof Array ? [] : {};
      for (var item in obj) {
        if (obj.hasOwnProperty(item)) {
          newObj[item] =
            typeof obj[item] === "object" ? deepCopy(obj[item]) : obj[item];
        }
      }
      return newObj;
    },
    resetEmployeeForm(formName) {
      this.$refs[formName].resetFields();
    },

    /* by guo 2019-08-20 17：20 修改 */
    // editResetEmployeeForm(formName) {
    //   this.$refs[formName].resetFields()
    //   this.editEmploeeData = {}
    //   this.EditdDeptId = ''
    // },
    transformEmployeeInfo(item) {
      // 获取员工到部门名称后再添加入列表
      var employee = {};
      employee.userName = item.userName;
      employee.loginName = item.loginName;
      employee.idCard = item.idCard;
      employee.mobileNo = item.mobileNo;
      employee.empDate = item.empDate;
      employee.position = item.position;
      employee.famliyAddr = item.famliyAddr;
      employee.department = item.deptName;
      employee.userId = item.userId;
      employee.lastLoginTime = item.lastLoginTime;
      employee.age = item.age;
      employee.sex = item.sex == "1" ? "男" : "女";
      employee.roleName = item.roleName; //by guo 2019-8-7 10:24 添加  角色
      employee.roleId = item.roleId; //by guo 2019-8-7 10:24 添加  角色roleId
      employee.educationLevel = String(item.educationLevel); //
      employee.personnelType = String(item.personnelType); //
      this.dataList.push(employee);
    },

    hasSubDept(data) {
      var empList = [];
      var children = []; // children放这里如果放在下面的for循环里---在没有子部门的时候emplist会报错
      if (data.empVoList && data.empVoList.length > 0) {
        data.empVoList.forEach((item) => {
          var empObj = {};
          empObj.id = id++;
          empObj.label = item.userName;
          empList.unshift(empObj);
        });
        // 员工添加到和子部门同级
        if (empList && empList.length > 0) {
          empList.forEach((item) => {
            children.unshift(item);
          });
        }
      }

      if (data.subDept != null && data.subDept.length > 0) {
        // var children = []
        data.subDept.forEach((item) => {
          var obj = {};
          obj.id = item.id;
          //当改变部门的时候--这时他的部门就会优先出现在顶层，ID和deptName绑在了一起
          obj.label = item.deptName;
          obj.deptName = item.deptName;
          obj.pid = item.pid;
          obj.hasDept = item.hasDept;
          obj.empVoList = item.empVoList;
          obj.desc = item.remark;
          obj.children = this.hasSubDept(item); // 如果有item.subDept --- 更新obj.children
          children.push(obj);
          if (item.deptName) {
            var deptObj = {};
            deptObj.value = item.id;
            deptObj.label = item.deptName;
            this.AllDeapartments.push(deptObj);
            this.EidtAllDeapartments.push(deptObj);
          }
        });
      }
      return children;
    },
    getDepartInfo() {
      let param = {};
      this.$postForm("uac/dept/getDeptVoAll", param).then((res) => {
        this.AllDeapartments = []; //by guo 2019-11-18-14:02添加
        if (res.code === 200) {
          var department = res.result[0];
          this.institutionId = department.id;
          this.searchEmployeeParams.deptId = department.id; //by guo 2019 3-26 添加
          // 拿到机构ID点后就获取所有的员工
          this.getAllEmployeeLen();
          this.searchEmployeeByDeptId();
          this.employeesList = department.empVoList;
          var Treedata = [];
          var organization = {};
          organization.id = department.id;
          organization.label = department.deptName;
          organization.deptName = department.deptName; //区分部门和员工
          organization.pid = department.pid; //判断根部门
          organization.hasDept = department.hasDept; //判断是否有子部门
          organization.empVoList = department.empVoList; //判断是否有员工
          organization.desc = department.remark; //编辑回显
          if (department.deptName) {
            var deptObj = {};
            deptObj.value = department.id;
            deptObj.label = department.deptName;
            this.AllDeapartments.push(deptObj);
            this.EidtAllDeapartments.push(deptObj);
          }
          // 递归子部门
          var childrens = this.hasSubDept(department);

          if (childrens && childrens.length > 0) {
            organization.children = childrens;
          }
          Treedata.push(organization);
          this.Treedata = Treedata;

          // 默认展示一级子节点
          var firstClassNode = Treedata[0].id;
          this.firstClassNodeIds.push(firstClassNode);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    searchEmployeeByDeptId() {
      let params = {
        pageNum: this.searchEmployeeParams.pageNum,
        pageSize: this.searchEmployeeParams.pageSize,
        deptId: this.searchEmployeeParams.deptId,
      };
      this.$postJson("uac/emp/queryUserListByEmpWithPage", params).then(
        (res) => {
          this.dataList = []; //请求数据之前清空
          if (res.code == 200) {
            this.tabelLen = +res.result.total;
            // 如果是机构下面的人就显示直属机构下面的人
            // if(this.tabelLen > 0 && this.institutionId == params.deptId) {
            //   this.currentEmployeeCount = this.employeesList.length
            // }else {
            //   this.currentEmployeeCount = +res.result.total
            // }
            this.currentEmployeeCount = +res.result.total;
            if (this.tabelLen == 0) {
              this.currentEmployeeCount = 0;
            }
            var list = res.result.list;
            if (list && list.length > 0) {
              list.forEach((item) => {
                this.transformEmployeeInfo(item);
              });
            }
          } else {
            this.$message.error(res.message);
          }
        }
      );
    },
    getAllEmployeeLen() {
      let params = {
        pageNum: 1,
        pageSize: 5,
        deptId: this.institutionId,
      };
      // this.$postJson('uac/emp/queryEmpListWithPage', params).then(res => {
      //by guo 2019-8-7 10:16 修改  新接口多了角色的字段
      this.$postJson("uac/emp/queryUserListByEmpWithPage", params).then(
        (res) => {
          if (res.code == 200) {
            this.AllEmployees = +res.result.total;
          } else {
            this.$message.error(res.message);
          }
        }
      );
    },

    /* 
        获取该机构初始化的所有的角色   by guo 2019-8-7 9:53添加
      */
      getRoleInfo(groupId) {
      this.$postJson("uac/role/queryListWithPage",{pageNum:1,pageSize:30,creator:'admin'}).then(
        (res) => {
          if (res.result.list.length > 0 || res.result != null) {
            res.result.list.forEach((item) => {
              if(item.roleCode!='admin'){
                let roleObj = {};
                roleObj.label = item.roleName; //角色名称
                roleObj.roleCode = item.roleCode; //角色编码
                roleObj.value = item.id; //角色id
                this.roleOptions.push(roleObj);
              }
            });
          }
        }
      );
    },
  },
  created() {
    this.getDepartInfo();
    this.groupId = sessionStorage.getItem("groupId"); // 获取机构id  by guo 2019-08-21 13:09添加
  },
  mounted() {
    this.getRoleInfo(this.groupId);
  },
};
</script>
<style lang="scss" scoped>
.department {
  margin-top: 6px;
  display: flex;
  min-height: 600px;
  background: #fff;
  ::v-deep .table-base {
    padding: 20px !important;
    box-sizing: border-box;
  }
  .tree-content {
    // flex: 0 0 370px;  // 需要定义不缩放0不然会自动缩放
    border: 1px solid #ccc;
    display: inline-block;
    .people {
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-size: 14px;
      font-weight: 700px;
      border-bottom: 2px solid #ccc;
    }
    .tree {
      // width: 200px;
      width: 230px; // by guo 2019 3-26 修改
      display: inline-block;
      // position: relative;
      .custom-tree-nodes {
        .title-label {
          display: inline-block;
          width: 160px;
          height: 16px;
          line-height: 16px;
          overflow: hidden;
          vertical-align: middle;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .button-operator {
          // position: absolute;
          // width: 200px;
          position: absolute; // by guo 2019 3-26 修改
          left: 160px; // by guo 2019 3-26 修改
          padding-right: 5px;
          vertical-align: middle;
          i {
            font-size: 12px;
            font-weight: 900;
          }
          // &.slide-enter-active, &.slide-leave-active {
          //   transition: all 0.5s;
          // }
          // &.slide-enter, &.slide-leave-to {
          //   position: absolute;
          //   left: 100%;
          //   transform: translate3d(-100%, 0, 0);
          // }
        }
      }
    }
  }
  .table-content {
    flex: 1;
    display: inline-block;
    border: 1px solid #ccc;
    margin-left: 10px;
    .title-btn {
      position: relative;
      top: -1px;
    }
  }
  ::v-deep .el-dialog {
    .el-dialog__header {
      border-bottom: 1px solid #ccc;
      background: #e4e4e4;
    }
    .dialog-footer {
      text-align: center;
    }
  }
  .operator {
    .operatorEdit {
      color: #3f7be2;
      margin-right: 20px;
    }
    .operatorDelete {
      color: #e40d0d;
    }
    // .el-button--mini {
    //   margin-left: 0px;
    //   padding: 0px;
    //   border: 0;
    //   font-size: 14px;
    // }
  }
  .add-employee,
  .edit-employee {
    .el-form {
      display: flex;
      .left-form {
        width: 49%;
        box-sizing: border-box;
        overflow: hidden;
        display: inline-block;
      }
      .right-form {
        width: 48%;
        box-sizing: border-box;
        display: inline-block;
      }
    }
  }
  .people-img {
    width: 10px;
    height: 10px;
    display: inline-block;
    // border:1px solid #f01400;
    margin-left: -22px;
    margin-right: 8px;
    padding-right: 0;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
::v-deep .el-tree-node {
  width: 250px;
}
//  ::v-deep深度作用选择符
::v-deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
</style>
